/*tslint:disable:no-bitwise */
import {Component, NgZone, Injectable} from '@angular/core';
import {
  Http,
  Response,
  RequestOptionsArgs,
  RequestOptions,
  Headers
} from '@angular/http';
import { map } from 'rxjs/operators';
import {UtilitiesService} from '../utilities.service';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { RealtorPortalService } from './realtor-portal.service';

@Injectable()
export class ApiAccessService {
  static authenicationInformation: any;
  static fromFederatedLogin = false;

  private static Base64 = {
    _keyStr:
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
    encode: function(input) {
      let output = '';
      let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
      let i = 0;
      input = ApiAccessService.Base64._utf8_encode(input);
      while (i < input.length) {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }
        output = output + this._keyStr.charAt(enc1) +
                 this._keyStr.charAt(enc2) + this._keyStr.charAt(enc3) +
                 this._keyStr.charAt(enc4);
      }
      return output;
    },
    _utf8_encode: function(string) {
      string = string.replace(/\r\n/g, '\n');
      let utftext = '';
      for (let n = 0; n < string.length; n++) {
        const c = string.charCodeAt(n);
        if (c < 128) {
          utftext += String.fromCharCode(c);
        } else if ((c > 127) && (c < 2048)) {
          utftext += String.fromCharCode((c >> 6) | 192);
          utftext += String.fromCharCode((c & 63) | 128);
        } else {
          utftext += String.fromCharCode((c >> 12) | 224);
          utftext += String.fromCharCode(((c >> 6) & 63) | 128);
          utftext += String.fromCharCode((c & 63) | 128);
        }
      }
      return utftext;
    },
  };

  static clearLoginInfo() { localStorage.removeItem('login-info'); }

  static get isLoggedIn() {
    try {
      if (localStorage.getItem('login-info')) {
        const loginInfo = JSON.parse(localStorage.getItem('login-info'));
        if (loginInfo && loginInfo.userName && loginInfo.password) {
          return true;
        }
      }
    } catch (e) {
    }

    return false;
  }

  public static get userName() {
    try {
      if (localStorage.getItem('login-info')) {
        const loginInfo = JSON.parse(localStorage.getItem('login-info'));
        if (loginInfo && loginInfo.userName && loginInfo.password) {
          return loginInfo.userName;
        }
      }
    } catch (e) {
    }

    return null
  }

  public static get password() {
    try {
      if (localStorage.getItem('login-info')) {
        const loginInfo = JSON.parse(localStorage.getItem('login-info'));
        if (loginInfo && loginInfo.userName && loginInfo.password) {
          return loginInfo.password;
        }
      }
    } catch (e) {
    }

    return null
  }

  static setLoginInfo(userName: string, password: string) {
    localStorage.setItem(
        'login-info', JSON.stringify({userName: userName, password: password}));
  }

  constructor(private http: Http) {}

  private serializeDate(date: Date): string {
    let hour = date.getHours().toString();
    if (hour.length === 1) {
      hour = '0' + hour;
    }
    let min = date.getMinutes().toString();
    if (min.length === 1) {
      min = '0' + min;
    }
    let sec = date.getSeconds().toString();
    if (sec.length === 1) {
      sec = '0' + sec;
    }

    return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' +
           date.getDate() + ' ' + hour + ':' + min + ':' + sec + '.000';
  }



  private getRequestOptionsArgs(): RequestOptions {
    const headers = new Headers();
    if (localStorage.getItem('login-info')) {
      const loginInfo = JSON.parse(localStorage.getItem('login-info'));
      headers.append('Authorization',
                     'Basic ' +
                         ApiAccessService.Base64.encode(
                             loginInfo.userName + ':' + loginInfo.password));
    } else if (sessionStorage.getItem('login-info')) {
      const loginInfo = JSON.parse(sessionStorage.getItem('login-info'));
      headers.append('Authorization',
                     'Basic ' +
                         ApiAccessService.Base64.encode(
                             loginInfo.userName + ':' + loginInfo.password));
    }
    return new RequestOptions({headers: headers});
  }

  delete (parameters: ApiAccessParameters): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = UtilitiesService.baseAPIUrl + parameters.url;
      if (parameters.parameters) {
        let first = true;
        for (const property in parameters.parameters) {
          if (parameters.parameters.hasOwnProperty(property)) {
            url += first ? '?' : '&';
            first = false;
            if (parameters.parameters[property] &&
                parameters.parameters[property].toUTCString) {
              // Remove time zone information from the date before sending as a
              // query string parameter
              url += property + '=' + encodeURIComponent(this.serializeDate(
                                          parameters.parameters[property]));
            } else {
              url += property + '=' +
                     encodeURIComponent(parameters.parameters[property]);
            }
          }
        }
      }

      this.http.delete(url, this.getRequestOptionsArgs())
          .map(res => res.text() ? res.json() : {})
          .subscribe(
              results => resolve(results),
              error => this.logError(error, 'DELETE', parameters, reject));
    });
  }

  getByUrl(url: string, parameters: any = null): Promise<any> {
    return this.get(new ApiAccessParameters(url, parameters));
  }

  undoDelete(url: string): Promise<any> {
    return this.patch(new ApiAccessParameters(url, {deleteddate: null}));
  }

  get(parameters: ApiAccessParameters): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = '';
      let isApiEndpoint = true;
      if (parameters.url.toLowerCase().indexOf('https://') === -1) {
        url = UtilitiesService.baseAPIUrl + parameters.url;
      } else {
        url = parameters.url;
        isApiEndpoint = false;
      }
      if (parameters.parameters) {
        let first = true;
        for (const property in parameters.parameters) {
          if (parameters.parameters.hasOwnProperty(property)) {
            url += first ? '?' : '&';
            first = false;
            if (parameters.parameters[property] &&
                parameters.parameters[property].toUTCString) {
              // Remove time zone information from the date before sending as a
              // query string parameter
              url += property + '=' + encodeURIComponent(this.serializeDate(
                                          parameters.parameters[property]));
            } else {
              url += property + '=' +
                     encodeURIComponent(parameters.parameters[property]);
            }
          }
        }
      }

      this.http.get(url, isApiEndpoint ? this.getRequestOptionsArgs() : null)
          .map(res => res.json())
          .subscribe(results => {
            this.mapResults(results, parameters, resolve);
          }, error => this.logError(error, 'GET', parameters, reject));
    });
  }

  private logError(error, method: string, parameters: ApiAccessParameters, reject) {
    if (!parameters.surpressApiError) {
      // TODO: log this somehow
    }
    if (reject) {
      reject(error);
    }
  }

  convertToModelType(typeCreator: () => any, source: any) {
    const dateExpression = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?$/;
    const shapedResult = typeCreator();
    for (const key in source) {
      if (dateExpression.test(source[key])) {
        shapedResult[key] = new Date(source[key]);
      } else {
        shapedResult[key] = source[key];
      }
    }

    return shapedResult;
  }

  private mapResults(results, parameters: ApiAccessParameters, resolve) {
    if (!results) {
      resolve(results);
      return;
    }

    if (parameters.typeCreator == null) {
      resolve(results);
    } else {
      // We want to convert this data from the wire into the actual types the
      // client is expecting.
      if (results.forEach) {  // It's an array
        const shapedResults = [];
        results.forEach(item => {
          const shapedResult =
              this.convertToModelType(parameters.typeCreator, item);
          shapedResults.push(shapedResult);
        });
        resolve(shapedResults);
      } else {
        const shapedResult =
            this.convertToModelType(parameters.typeCreator, results);
        resolve(shapedResult);
      }
    }
  }

  getHtml(parameters: ApiAccessParameters): Promise<string> {
    return new Promise((resolve, reject) => {
      let url = '';

      if (parameters.url.indexOf('http://') === -1 &&
          parameters.url.indexOf('https://') === -1) {
        url = UtilitiesService.baseAPIUrl + parameters.url;
      } else {
        url = parameters.url;
      }

      if (parameters.parameters) {
        let first = true;
        for (const property in parameters.parameters) {
          if (parameters.parameters.hasOwnProperty(property)) {
            url += first ? '?' : '&';
            first = false;
            url += property + '=' +
                   encodeURIComponent(parameters.parameters[property]);
          }
        }
      }

      this.http.get(url, this.getRequestOptionsArgs())
          .map(res => res.text())
          .subscribe(results => { resolve(results); },
                     error => this.logError(error, 'GET', parameters, reject));
    });
  }

  post(parameters: ApiAccessParameters): Promise<any> {
    const url = UtilitiesService.baseAPIUrl + parameters.url;

    return new Promise((resolve, reject) => {
      const objectToPost = parameters.parameters;

      if (objectToPost.hasOwnProperty('length')) {
        objectToPost.forEach(obj => this.initializeCommonProperties(obj));
      } else {
        this.initializeCommonProperties(objectToPost);
      }

      this.http.post(url, objectToPost, this.getRequestOptionsArgs())
          .map(res => res.text() ? res.json() : null)
          .subscribe(results => {
            this.mapResults(results, parameters, resolve);
          }, error => this.logError(error, 'POST', parameters, reject));
    });
  }

  private initializeCommonProperties(objectToPost: any) {
    if (objectToPost.hasOwnProperty('createdDate') &&
        !objectToPost.createdDate) {
      objectToPost.createdDate = new Date();
    }

    if (objectToPost.hasOwnProperty('id') && !objectToPost.id) {
      objectToPost.id = UtilitiesService.newid();
    }

    if (objectToPost.hasOwnProperty('createdById') &&
        !objectToPost.createdById) {
      objectToPost.createdById = ApiAccessService.authenicationInformation.id;
    }

    // Recursively search the object tree for properties to populate
    for (const prop in objectToPost) {
      if (objectToPost.hasOwnProperty(prop) && objectToPost[prop] != null &&
          typeof objectToPost[prop] === 'object') {
        this.initializeCommonProperties(objectToPost[prop]);
      } else if (objectToPost[prop] == null) {
        delete objectToPost[prop];
      }
    }
  }

  patch(parameters: ApiAccessParameters): Promise<any> {
    const url = UtilitiesService.baseAPIUrl + parameters.url;

    return new Promise((resolve, reject) => {
      this.http.patch(url, parameters.parameters, this.getRequestOptionsArgs())
          .map(res => res.text() ? res.json() : null)
          .subscribe(results => {
            this.mapResults(results, parameters, resolve);
          }, error => this.logError(error, 'PATCH', parameters, reject));
    });
  }


  put(parameters: ApiAccessParameters): Promise<any> {
    const url = UtilitiesService.baseAPIUrl + parameters.url;

    return new Promise((resolve, reject) => {
      this.http.put(url, parameters.parameters, this.getRequestOptionsArgs())
          .subscribe(results => { resolve(results); });
    });
  }
}

export class ApiAccessParameters {
  constructor(public url = '', public parameters: any = null,
              public typeCreator: () => any = null,
              public surpressApiError = false) {}
}
